import React, { Component } from 'react';
import { connect } from 'react-redux';
import { deactivateOverlayAction } from '@/services/ui/overlay/actions';

import Form from '@/components/_common/Form';
import TextField from '@/components/_common/Form/inputs/TextField';
import Dob from '@/components/_common/Form/inputs/Dob';
import Select from '@/components/_common/Form/inputs/Select';
import Checkbox from '@/components/_common/Form/inputs/Checkbox';
import countries from '@/data/countries.json';

import validateForm from '@/components/_common/Form/validate';

import { HEADER_COPY, BODY_COPY, CTA_COPY } from "@/utils/content-keys";
import { post } from "@/utils/api";
import { getCaptchaToken } from "../../ReCaptcha";
import tracking from '@/utils/tracking';

class SignUpForm extends Component {
	state = {
		step: 1,
		fields: {
			first_name: { value: '', showError: false },
			last_name: { value: '', showError: false },
			email: { value: '', showError: false },
			country: { value: '', showError: false },
			country_code: { value: '', showError: false },
			dob: { day: '', month: '', year: '', showError: false },
			subscribe_brand_news: { value: false, showError: false }
		}
	};

	moduleNames = [
		{ name: 'Sign up - overlay screen 1', title: 'Screen1' },
		{ name: 'Sign up - overlay screen 2', title: 'Screen2' },
		{ name: 'Sign up - already subscribed', title: 'Screen3' },
		{ name: 'Form field 1 - YOUR EMAIL', title: 'Field1' }
	];

	componentDidMount() {
		if (!this.props.data.fetchedData) {
			this.props.fetchData(
				{ name: 'signUpForm', modules: this.moduleNames, transform: true },
				true,
				'NEWSLETTER OVERLAY'
			);
		}
		else {
			console.log('SignUpForm - data fetched');
		}
	}

	onFormChange = (value, name, key = 'value') => {
		
		this.setState((state) => (state.fields[name][key] = value));
	};
	onFormCountryChange = (value, name, key = 'value') => {
		const countryCode = countries.filter((country) => country.abbr === value)[0].code ? countries.filter((country) => country.abbr === value)[0].code :'1';
		this.setState((state) => (state.fields[name][key] = value));
		this.setState((state) => (state.fields['country_code'][key] = countryCode));
	};

	onSubmit = async () => {
		const token = await getCaptchaToken("newsletter");
		if (this.state.step > 1) {
			return this.props.deactivateOverlayAction();
		}

		const { fields } = this.state;
		const data = { token };

		Object.keys(fields).forEach((key) => (data[key] = fields[key].value || ''));
		data.dob = `${fields.dob.year}-${fields.dob.month}-${fields.dob.day}`;
		data.websiteUrl = window.location.origin;
		console.log(data);
		try {
			const response = await post(data, 'submit-newsletter');

			if (response.error) {
				if (response.error === 'duplicate') {
					return this.setState({ step: 3 });
				}

				if (response.error === 'under_18') {
					tracking.event('customEvent', {
						eventCategory: 'Sign Up Form',
						eventAction: 'error',
						eventLabel: `under 18, source: ${this.props.routeProps.location.pathname}`
					});
					return alert('You must be 18 or over');
				}

				tracking.event('customEvent', {
					eventCategory: 'Sign Up Form',
					eventAction: 'error',
					eventLabel: `${response.error}, source: ${this.props.routeProps.location.pathname}`
				});
				return alert(response.error);
			}

			tracking.event('customEvent', {
				eventCategory: 'Sign Up Form',
				eventAction: 'submit',
				eventLabel: `source: ${this.props.routeProps.location.pathname}`
			});
			tracking.pageView('/newsletter-subscribe/thank-you');
			this.setState({ step: 2 });
		}
		catch (e) {
			tracking.event('customEvent', {
				eventCategory: 'Sign Up Form',
				eventAction: 'error',
				eventLabel: `${e}, source: ${this.props.routeProps.location.pathname}`
			});
			alert(e);
			console.error(e);
		}
	};

	render() {
		const { step } = this.state;
		const { contents } = this.props.data;

		if (!contents) {
			return null;
		}

		return (
			<Form className="sign-up-form" finalStep={step >= 2}>
				<h1 className="form__headline">
					{contents[`Screen${step}`][0][HEADER_COPY].value}
				</h1>
				<p className="form__copy">
					{contents[`Screen${step}`][0][BODY_COPY].value}
				</p>
				{step === 1 && (
					<p className="form__copy">
						By submitting this form, you agree to receive email updates from
						Open Gate Brewery.
					</p>
				)}
				{step === 1 && (
					<div className="form__fields">
						<TextField
							label="Your first name*"
							name="first_name"
							id="firstName"
							placeholder="ENTER YOUR FIRST NAME"
							field={this.state.fields.first_name}
							onChange={this.onFormChange}
						/>

						<TextField
							label="Your last name*"
							name="last_name"
							id="lastName"
							placeholder="ENTER YOUR LAST NAME"
							field={this.state.fields.last_name}
							onChange={this.onFormChange}
						/>

						<label className="form__label">Your date of birth*</label>
						<Dob
							name="dob"
							field={this.state.fields.dob}
							onChange={this.onFormChange}
						/>

						<Select
							label="Your country of residence*"
							placeholder="SELECT YOUR COUNTRY"
							name="country"
							id="country"
							options={countries}
							field={this.state.fields.country}
							onChange={this.onFormCountryChange}
						/>

						<TextField
							label="Your email*"
							name="email"
							id="email"
							placeholder="ENTER YOUR EMAIL"
							field={this.state.fields.email}
							onChange={this.onFormChange}
							errorMessage="*Please enter a valid email address"
						/>

						<Checkbox
							label="Tick here if you would like us to use your email to keep you informed about products, services and events from Open Gate Brewery & other Diageo brands.
							We’ll occasionally send you messages and show you ads for things that we think may be of interest."
							name="subscribe_brand_news"
							id="subscribe_brand_news"
							field={this.state.fields.subscribe_brand_news}
							onChange={this.onFormChange}
							errorMessage="*Please check the box above if you would like to proceed"
						/>
					</div>
				)}
				<button
					className="cta cta--lg-font form__cta"
					onClick={() =>
						this.setState(
							validateForm('Sign Up Form', this.props.routeProps, this.onSubmit)
						)
					}
				>
					{contents[`Screen${step}`][0][CTA_COPY].value}
				</button>
				{step === 1 && (
					<div className="form__legal">
						<p className="form__copy">
							By signing up, you accept Diageo's <a
								href="https://footer.diageohorizon.com/dfs/assets/www.guinnessopengate.com/TnC_en.html?locale=en-ie"
								className="form__copy--link"
								target="_blank" rel="noreferrer"
							>Conditions of Use</a> and acknowledge the{' '} 
							<a
								href="https://footer.diageohorizon.com/dfs/assets/www.diageo.com/PrivacyPolicy_en.html?locale=en-gb"
								className="form__copy--link"
								target="_blank" rel="noreferrer"
							>Privacy & Cookie Notice</a>. Please see the ‘Disclosure of your personal data’ section of our{' '} 
							<a
								href="https://footer.diageohorizon.com/dfs/assets/www.diageo.com/PrivacyPolicy_en.html?locale=en-gb"
								className="form__copy--link"
								target="_blank" rel="noreferrer"
							>Privacy & Cookie Notice</a> for further information on how we share your data with our marketing partners. You can unsubscribe at any time.
						</p>
					</div>
				)}
			</Form>
		);
	}
}

export default connect((state) => ({}), { deactivateOverlayAction })(
	SignUpForm
);



// WEBPACK FOOTER //
// ./src/components/_common/SignUpForm/index.js